import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-stock-zone',
  templateUrl: './stock-zone.component.html',
  styleUrls: ['./stock-zone.component.css']
})
export class StockZoneComponent implements OnInit {
    stockPlaceId;

    public stockZoneKeyno;

    public edit?: Edit;

    public selectListStockZoneClasses: StockZoneClassItem[] = [];

    public selectListWareHouses: WareHouseItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.stockPlaceId = this.stateService.getStateParams()['stockplace_id'];
        this.stockZoneKeyno = this.stateService.getStateParams()['stockzone_keyno'];
    }

    private async loadEdit() {
        if (!!this.stockPlaceId && !!this.stockZoneKeyno) {
            this.edit = (await this.datatask.Post(931, {
                stockplace_id: this.stockPlaceId,
                stockzone_keyno: this.stockZoneKeyno
            }))[0];
        }
    }

    private async loadStockZoneClasses(): Promise<void> {
        this.selectListStockZoneClasses = await this.datatask.Post(1028);
    }

    private async loadWareHouses(): Promise<void> {
        if (!!this.edit) {
            this.selectListWareHouses = await this.datatask.Post(2542, { stockplace_id: this.edit?.stockplace_id });
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(932, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(933, this.edit);

                    this.stateService.back(2);
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadStockZoneClasses();
        this.loadWareHouses();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    stockzone_keyno: number;
    stockzone_name: string;
    stockplace_id: string;
    stockplace_name: string;
    isactive: number;
    stockzoneclass_keyno: number;
    warehouse_keyno: number;
}

interface StockZoneClassItem {
    stockzoneclass_keyno: number;
    stockzoneclass_name: string;
    singlelocation: number;
    allocate_possible: number;
    orderby: number;
}

interface WareHouseItem {
    stockplace_id: string;
    stockplace_name: string;
    warehouse_keyno: number;
    warehouse_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockZone', {
//        templateUrl: 'views/components/views/stockZone/stockZone.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'stockZoneService', function ($stateParams, stateService, utilityService, translateService, modalService, stockZoneService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockPlaceId = $stateParams.stockplace_id;
//            let stockZoneKeyno = $stateParams.stockzone_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListStockZoneClasses: [],
//                selectListWareHouses: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALL

//            async function loadEdit() {
//                vm.model.edit = (await stockZoneService.getEdit({
//                    stockplace_id: stockPlaceId,
//                    stockzone_keyno: stockZoneKeyno
//                }))[0];

//                return loadWareHouses();
//            }

//            async function loadStockZoneClasses() {
//                vm.model.selectListStockZoneClasses = await stockZoneService.listStockZoneClasses();
//            }

//            async function loadWareHouses() {
//                if (utilityService.validateParmsValue(vm.model.edit.stockplace_id, true) !== true) return;

//                return vm.model.selectListWareHouses = await stockZoneService.listWareHouses({ stockplace_id: vm.model.edit.stockplace_id });
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                stockZoneService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    stockZoneService.deleteItem(vm.model.edit).then(function () {
//                        vm.model.lockedDelete = false;
//                        stateService.back('/' + 'stockzones');
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadStockZoneClasses();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
